<div class="card">
  <div class="card-body">
    <app-line-chart [series]="series"></app-line-chart>
  </div>
</div>
